import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Select,
  Typography,
  InputLabel,
  MenuItem,
  FormControl,
  TextField,
  CircularProgress,
  Grid,
} from "@mui/material";
import SleepChart from "../Charts/SleepChart";
import SugarIntakeChart from "../Charts/SugarIntakeChart";
import WaterIntakeChart from "../Charts/WaterIntakeChart";
import SmokingChart from "../Charts/SmokingChart";
import ChartRecommendationItem from "../../commons/ChartRecommendationItem";
import SelectComponent from "../../commons/SelectComponent";
import LineChartWeek from "../Charts/LineChart";

const chartPaperStyle = {
  // opacity: "30%",
  display: "flex",
  height: "150px",
  // backgroundColor: "rgba(255, 255, 255, 0.3)",
  // boxShadow: '0px 4px 4px rgba(0,0,0,0.15)',
  m: 1,
  borderRadius: "10px",
  p: 1,
  border:"1px solid #E5E7EB", boxShadow:'none'
};

const chartRecommendationStyle = {
  display: "flex",
  flexDirection: "column",
  width: "40%",
  height:'100%',
  pl: 3,
  justifyContent:'center'
  // py: 2,
};

function LifestyleCharts({
  patientId,
  lifestyleGraphs,
  sugarIntake,
  sugarNotes,
  sugarData,
  sleepDuration,
  sleepNotes,
  sleepData,
  smokingStatus,
  smokingNotes,
  smokingData,
  waterIntake,
  waterNotes,
  waterData,
  sleepChartData,
  smokingChartData,
  waterChartData,
  sugarChartData,
  handleSugarChange,
  handleSugarNotesChange,
  handleSleepChange,
  handleSleepNotesChange,
  handleSmokingChange,
  handleSmokingNotesChange,
  handleWaterChange,
  handleWaterNotesChange,
  patientReducer,
  edit,
}) {
  if (patientReducer.requestState) {
    return (
      <Box
        sx={{
          width: "40%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 300,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>

      <Grid container spacing={0.5}>
  <Grid size={{ xs:12, md:6, lg:6 , xl:12}}>
        <Paper
          elevation={3}
          sx={{
            ...chartPaperStyle,
          }}
        >
          <Box sx={{ width: "85%"  }}>
            <LineChartWeek
              title={sleepData?.graphLabel}
              idealValue={sleepData?.recommendation}
              data={sleepData?.values}
            />
          </Box>

          <Box
            sx={{
              ...chartRecommendationStyle,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                height: '90%',
                justifyContent: 'space-between',
              }}
            >
              <Box sx={{ alignSelf:'flex-start', display:'flex', flexDirection:'column'}}>
              <Typography align="left" variant="p" fontSize={"10px"}>
                Recommendation:
              </Typography>
              <SelectComponent
                data={sleepChartData}
                value={sleepDuration}
                onChange={handleSleepChange}
                disabled={!edit}
              />
              </Box>
              <Box sx={{ alignSelf:'flex-start', display:'flex', flexDirection:'column',  width:'100%'}}>

              <Typography align="left" variant="p" fontSize={"10px"}>
                Notes:
              </Typography>
              <TextField
                multiline
                minRows={2}
                maxRows={2}
                disabled={!edit}
                // placeholder="Type your text here..."
                value={sleepNotes}
                onChange={handleSleepNotesChange}
                variant="outlined"
                fullWidth
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "5px",
                    backgroundColor: "#FFF",
                    // boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    padding: "8px 12px",
                    "& fieldset": {
                      border: "1px solid #E5E7EB",
                    },
                    fontSize: "10px",
                    marginTop: 1,
                  },
                }}
              />
              </Box>
            </Box>
          </Box>
        </Paper>
        </Grid>
        {/* <Grid size={{ xs:12, md:6, lg:6, xl:12 }}>
        <Paper
          elevation={3}
          sx={{
            ...chartPaperStyle,
            
          }}
        >
          <SugarIntakeChart
            sugarChartData={sugarChartData?.answers}
            page={"Lifestyle"}
            title={sugarData?.graphLabel}
            idealValue={sugarData?.recommendation}
          />

          <Box
            sx={{
              ...chartRecommendationStyle,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                height: '90%',
                justifyContent: 'space-between',
              }}
            >
              <Box sx={{ alignSelf:'flex-start', display:'flex', flexDirection:'column'}}>
              <Typography align="left" variant="p" fontSize={"10px"}>
                Recommendation:
              </Typography>
              <SelectComponent
                data={sugarChartData}
                value={sugarIntake}
                onChange={handleSugarChange}
                disabled={!edit}
              />
              </Box>
              <Box sx={{ alignSelf:'flex-start', display:'flex', flexDirection:'column',  width:'100%'}}>

              <ChartRecommendationItem color={"#C8EDF5"} label={"Actual"} />
              <ChartRecommendationItem
                color={"#D3E0E8"}
                label={"Recommended"}
              />
              <Typography align="left" variant="p" fontSize={"10px"}>
                Notes:
              </Typography>
              <TextField
                multiline
                minRows={2}
                maxRows={2}
                disabled={!edit}
                // placeholder="Type your text here..."
                value={sugarNotes}
                onChange={handleSugarNotesChange}
                variant="outlined"
                fullWidth
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "5px",
                    backgroundColor: "#FFF",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    padding: "8px 12px",
                    "& fieldset": {
                      border: "none",
                    },
                    fontSize: "10px",
                    marginTop: 1,
                  },
                }}
              />
              </Box>
            </Box>
          </Box>
        </Paper>
        </Grid> */}

        <Grid size={{ xs:12, md:6, lg:6, xl:12}}>
        <Paper
          elevation={3}
          sx={{
            ...chartPaperStyle,
          }}
        >
          <Box sx={{ width: "85%" }}>
            <LineChartWeek
              title={waterData?.graphLabel}
              idealValue={waterData?.recommendation}
              data={waterData?.values}
            />
          </Box>
          <Box
            sx={{
              ...chartRecommendationStyle,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                height: '90%',
                justifyContent: 'space-between',
              }}
            >
            <Box sx={{ alignSelf:'flex-start', display:'flex', flexDirection:'column'}}>
              <Typography align="left" variant="p" fontSize={"10px"}>
                Recommendation:
              </Typography>
              <SelectComponent
                data={waterChartData}
                value={waterIntake}
                onChange={handleWaterChange}
                disabled={!edit}
              />
  </Box>
              <Box sx={{ alignSelf:'flex-start', display:'flex', flexDirection:'column'}}>

              <Typography align="left" variant="p" fontSize={"10px"}>
                Notes:
              </Typography>
              <TextField
                multiline
                minRows={2}
                maxRows={2}
                value={waterNotes}
                onChange={handleWaterNotesChange}
                disabled={!edit}
                // placeholder="Type your text here..."
                variant="outlined"
                fullWidth
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "5px",
                    backgroundColor: "#FFF",
                    // boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    padding: "8px 12px",
                    "& fieldset": {
                      border: "1px solid #E5E7EB",
                    },
                    fontSize: "10px",
                    marginTop: 1,
                  },
                }}
              />
                    </Box>
            </Box>
          </Box>
        </Paper>
        </Grid>

        {/* <Grid size={{ xs:12, md:6, lg:6, xl:12 }}>
        <Paper
          elevation={8}
          sx={{
            ...chartPaperStyle,
          }}
        >
          <SmokingChart
            smokingChartData={smokingChartData?.answers}
            page="Lifestyle"
            title={smokingData?.graphLabel}
            idealValue={smokingData?.recommendation}
          />

          <Box
            sx={{
              ...chartRecommendationStyle,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                height: '90%',
                justifyContent: 'space-between',
              }}
            >
              <Typography align="left" variant="p" fontSize={"10px"}>
                Recommendation:
              </Typography>
              <SelectComponent
                data={smokingChartData}
                value={smokingStatus}
                onChange={handleSmokingChange}
                disabled={!edit}
              />
              <Box
                sx={{
                  display: "flex",
                  // marginTop: "2px",
                  marginBottom: "8px",
                  alignItems: "center",
                }}
              >
                <Box
                  style={{
                    width: 7,
                    height: 7,
                    backgroundColor: "#FF6445",
                    // marginTop: "5px",
                    // marginBottom: "5px",
                    borderRadius: "50px",
                  }}
                />
                <Typography
                  align="left"
                  variant="p"
                  fontSize={"7px"}
                  marginLeft={"5px"}
                >
                  Smoking
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  // marginTop: "2px",
                  marginBottom: "8px",
                  alignItems: "center",
                }}
              >
                <Box
                  style={{
                    width: 7,
                    height: 7,
                    backgroundColor: "#C8EDF5",
                    borderRadius: "50px",
                  }}
                />
                <Typography
                  align="left"
                  variant="p"
                  fontSize={"7px"}
                  marginLeft={"5px"}
                >
                  Non Smoking
                </Typography>
              </Box>
              <Typography align="left" variant="p" fontSize={"10px"}>
                Notes:
              </Typography>
              <TextField
                multiline
                minRows={2}
                maxRows={2}
                value={smokingNotes}
                onChange={handleSmokingNotesChange}
                disabled={!edit}
                // placeholder="Type your text here..."
                variant="outlined"
                fullWidth
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "5px",
                    backgroundColor: "#FFF",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    padding: "8px 12px",
                    "& fieldset": {
                      border: "none",
                    },
                    fontSize: "10px",
                    marginTop: 1,
                  },
                }}
              />
            </Box>
          </Box>
        </Paper>
        </Grid> */}
      </Grid>
    </>
  );
}

export default React.memo(LifestyleCharts);
